export default __webpack_public_path__ + "a2b4f75f8890f0d0e670556b9ff697f7.webp";